import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    breadcrumb: {
      '& + *': {
        marginTop: muiTheme.spacing(2.5),
        [muiTheme.breakpoints.up('md')]: {
          marginTop: muiTheme.spacing(3.25),
          alignItems: 'flex-end',
          alignContent: 'flex-end',
        },
      },
    },
  }),
  { name: 'GenFilteredList' },
);

export default useStyles;
